import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, FillPath, StrokePath } from "./shared";

export function IconSpaceMaintainer(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M1.5 13.2C1.5 17.54 2.2 20.2 3.25 20.2C4.16 20.2 4.44 16.7 5 16.7C5.56 16.7 5.84 20.2 6.75 20.2C7.8 20.2 8.5 17.54 8.5 13.2" />
      <StrokePath d="M15.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M15.5 13.2C15.5 17.54 16.2 20.2 17.25 20.2C18.16 20.2 18.44 16.7 19 16.7C19.56 16.7 19.84 20.2 20.75 20.2C21.8 20.2 22.5 17.54 22.5 13.2" />
      <StrokePath d="M9.6 9.6h4.8M9.6 8v3.2M14.4 8v3.2" />
    </ClinicalIconSvg>
  );
}

export function IconRetentionWire(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(0 -5.4)">
        <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
        <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
      <StrokePath d="M3 10.6h18" />
    </ClinicalIconSvg>
  );
}

export function IconWaxUp(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath
        d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z"
        strokeDasharray="2.4 1.6"
      />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
    </ClinicalIconSvg>
  );
}

export function IconMockUp(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      <StrokePath d="M8 9h8" strokeDasharray="1.6 1.4" />
    </ClinicalIconSvg>
  );
}

export function IconOrthoStudyModel(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.4 12a8.6 8.6 0 0 1 17.2 0Z" />
      <StrokePath d="M7 12a5 5 0 0 1 10 0" />
      <StrokePath d="M2.4 15.6h19.2v4.2H2.4z" />
    </ClinicalIconSvg>
  );
}

export function IconCustomTray(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M12 1v5" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconWaxBite(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.4 10.6a8.6 8.6 0 0 1 17.2 0Z" />
      <StrokePath d="M3.4 13.4a8.6 8.6 0 0 0 17.2 0Z" />
      <StrokePath d="M3.4 12h17.2" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconAdditionalImpression(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M19.4 2.6v4.4M17.2 4.8h4.4" />
    </ClinicalIconSvg>
  );
}

export function IconUpperLowerModel(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M0.8 6.8v-3.5A1.5 1.5 0 0 1 1.8 1.8C3.2 1.4 6.2 0.8 12 0.8s8.8 0.6 10.2 1.1a1.5 1.5 0 0 1 1.0 1.4v3.5" />
      <StrokePath d="M5.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M9.8 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M14.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M18.8 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M23.3 6.8a2.3 2.3 0 0 0-4.5 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5Z" />
      <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
      <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      <StrokePath d="M9.4 12h5.2" strokeDasharray="1.6 1.4" />
    </ClinicalIconSvg>
  );
}

export function IconSiliconeKey(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
      <g transform="translate(0 0)">
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
    </ClinicalIconSvg>
  );
}

export function IconSurgicalGuide(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M2 6V3.6A1.6 1.6 0 0 1 3.6 2H6M18 2h2.4A1.6 1.6 0 0 1 22 3.6V6M22 18v2.4a1.6 1.6 0 0 1-1.6 1.6H18M6 22H3.6A1.6 1.6 0 0 1 2 20.4V18" />
      <g transform="translate(4.2 3.2) scale(.65)">
        <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
        <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      </g>
    </ClinicalIconSvg>
  );
}

export function IconReline(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g transform="translate(0 -3)">
        <StrokePath d="M0.8 17.3v3.5a1.5 1.5 0 0 0 1.1 1.4c1.4 0.4 4.4 1.1 10.2 1.1s8.8-0.6 10.2-1.1a1.5 1.5 0 0 0 1.0-1.4v-3.5" />
        <StrokePath d="M5.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M9.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M14.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M18.8 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
        <StrokePath d="M23.3 17.3a2.3 2.3 0 0 1-4.5 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5Z" />
      </g>
      <StrokePath d="M3.4 20.6h17.2" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconDigitalDesign(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M2.6 3h18.8a1.4 1.4 0 0 1 1.4 1.4v11.2a1.4 1.4 0 0 1-1.4 1.4H2.6a1.4 1.4 0 0 1-1.4-1.4V4.4A1.4 1.4 0 0 1 2.6 3ZM8.6 21.4h6.8M12 17v4.4" />
      <g transform="translate(6.6 4.2) scale(.45)">
        <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
        <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      </g>
    </ClinicalIconSvg>
  );
}

export function IconConsumables(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3 6.8h18s1.5 0 1.5 1.5v13.5s0 1.5-1.5 1.5H3s-1.5 0-1.5-1.5V8.3s0-1.5 1.5-1.5" />
      <StrokePath d="m22.3 7.5-2.4-5.9A1.5 1.5 0 0 0 18.5 0.8H5.5a1.5 1.5 0 0 0-1.4 0.9L1.7 7.5" />
      <StrokePath d="m12 6.8 0-6" />
      <StrokePath d="m14.3 18.8 4.5 0" />
    </ClinicalIconSvg>
  );
}
